import api from "../../../services/api";

const getById = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/document-control/by/" + state.id_user).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESBYID", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const getBydata = ({ state, commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/document-control/data/" + state.id_data).then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RESEDIT", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const get = ({ commit }) => {
  return new Promise((resolve, reject) => {
    api.get("/store").then(
      response => {
        const res = response.data;
        resolve(response);
        if (res.status) {
          commit("SET_RES", res.data);
        }
      },
      error => {
        reject(error);
      }
    );
  });
};
const putOrPush = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.put("/document-control", state.temp_input).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

const del = ({ state }) => {
  return new Promise((resolve, reject) => {
    api.delete("/document-control/" + state.id_data).then(
      response => {
        resolve(response);
      },
      error => {
        reject(error);
      }
    );
  });
};

export default {
  getById,
  putOrPush,
  del,
  get,
  getBydata
};
